<template>
  <div style="padding: 16px 0 16px 16px;">
    <Spin fix v-show="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>正在获取节点列表</div>
    </Spin>
    <span style="font-weight: bold; margin-right: 10px">节点列表</span>
    <Checkbox
      style="float: right;"
      :indeterminate="indeterminate"
      :value="checkAll"
      @click.prevent.native="actionCheckAll">全选</Checkbox>
    <Divider style="margin: 16px 0;"/>
    <CheckboxGroup v-model="selected" @on-change="nodeChange" vertical  :style="{maxHeight: height}" class="container-all-node-list">
      <p v-for="item in nodes" :key="item.id">
        <Checkbox :label="item.id">{{ item.name }}</Checkbox>
      </p>
    </CheckboxGroup>
  </div>
</template>

<script>
import { getAllNodes } from '@/api/container/node'
import { mapActions } from 'vuex'

export default {
  name: 'node-list',
  data () {
    return {
      nodes: [],
      nodesShow: true,
      error: false,
      loading: false,
      selected: [],
      indeterminate: false,
      checkAll: false,
      height: ''
    }
  },
  created: function () {
    this.getNodes()
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  watch: {
    selected () {
      this.saveSelContainerNodes(this.selected)
    }
  },
  methods: {
    ...mapActions([
      'saveSelContainerNodes'
    ]),
    getNodes () {
      this.loading = true
      getAllNodes().then(res => {
        this.nodes = res.data
        // this.actionCheckAll()
        this.selected = this.$store.state.container.selContainerNodes
        this.$emit('nodeChange')
        this.error = false
        this.loading = false
      }).catch(res => {
        this.error = true
        this.loading = false
        console.log(res.response)
      })
    },
    nodeChange (data) {
      if (data.length === this.nodes.length) {
        this.indeterminate = false
        this.checkAll = true
      } else if (data.length > 0) {
        this.indeterminate = true
        this.checkAll = false
      } else {
        this.indeterminate = false
        this.checkAll = false
      }
      this.$emit('nodeChange')
    },
    actionCheckAll () {
      if (this.indeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.indeterminate = false
      if (this.checkAll) {
        this.selected = this.nodes.map(item => item.id)
      } else {
        this.selected = []
      }
      this.$emit('nodeChange')
    },
    getHeight () {
      this.height = window.innerHeight - 170 + 'px'
    }
  }
}
</script>

<style lang='scss' scoped>
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  .container-all-node-list {
    padding: 0;
    overflow-y: auto;
    height: auto;
    padding-bottom: 5px;
  }
  .container-all-node-list::-webkit-scrollbar {
    width: 5px;
  }
  .container-all-node-list::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .container-all-node-list::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
